"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordValidationMsgs = void 0;
const passwordValidationMsgs = exports.passwordValidationMsgs = {
  UPPER_CASE: "Uppercase",
  LOWER_CASE: "Lowercase",
  LENGTH: "Min 8 Chars",
  SPECIAL_CHAR: "A Special Char",
  NUMBER: "Number"
};